<div class="row">
	<div class="col-lg-6">
		<div class="mb-3">
			<label>Organization to assign configuration to:</label>
			<select [(ngModel)]="selectedOrganization" class="form-control">
				@for (org of organizations; track org) {
				<option [ngValue]="org">{{org.name}}</option>
				}
			</select>
		</div>
	</div>
</div>
<div class="mb-3">
	<label>New Config XML:</label>
	<div>
		<textarea [(ngModel)]="newConfig" class="form-control" style="min-height: 400px;"></textarea>
	</div>
</div>
<app-action-button [action]="UploadConfig" [context]="this" processing="Uploading..." complete="Config added">Add Config</app-action-button>